import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { MAX_1279, MAX_1365, MAX_1679, MAX_767 } from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import MainButton from '~/src/components/form-components/main-button/main-button';
import { Z_INDEX } from '~/src/styles/tokens/z-index';

const paddingButtonStyles = css`
    padding: ${rem(10)} ${rem(24)};
`;

const newLeadButtonStyles = css`
    background-color: ${COLORS.controlsLightSecondaryActive};
    border: 2px solid ${COLORS.controlsLightSecondaryActive};
`;

const zIndexStyles = css`
    z-index: ${Z_INDEX.level1};
`;

const buttonMobileStyles = css`
    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            width: 100%;
        `,
    )};
`;

export const RecommendProductBannerContainer = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;
    max-height: fit-content;
    flex-direction: column;
    flex-wrap: nowrap;
    border-radius: ${BORDER_RADIUS.biggest20};
    padding: ${rem(32)};
    background-color: ${COLORS.backgroundLightSecondary};
    overflow: hidden;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            height: fit-content;
            padding: ${rem(32)} ${rem(16)};
        `,
    )};
`;

export const AboutProductBannerTitle = styled.h1<{ isShowCreateLead: boolean; }>`
    max-width: ${rem(703)};
    margin-bottom: ${rem(16)};
    ${FONTS.wide.medium.size24};
    color: ${COLORS.textLightPrimary};
    ${zIndexStyles};
	
	${p => css`
        ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            max-width: ${p.isShowCreateLead ? rem(610) : rem(580)};
        `,
    )}`};

    ${p => css`
        ${mediaQuery(
        { maxWidth: MAX_1365 },
        css`
            max-width: ${p.isShowCreateLead ? rem(460) : '70%'};
        `,
    )}`};
	
	${p => css`
        ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
	        text-align: center;
	        width: 100%;
	        margin: 0 auto ${p.isShowCreateLead ? rem(40) : rem(16)};
        `,
    )}`};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
        `,
    )};
`;

export const BottomContainer = styled.div<{ isShowCreateLead: boolean; }>`
    width: 100%;
    max-width: ${rem(529)};
    gap: ${rem(20)};
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            max-width: ${rem(529)};
        `,
    )};

    ${p => css`
        ${mediaQuery(
        { maxWidth: MAX_1365 },
        css`
            max-width: ${p.isShowCreateLead ? rem(460) : '100%'};
        `,
    )}`};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            gap: ${rem(32)};
        `,
    )};
`;

export const SubText = styled.span`
    position: relative;
    ${FONTS.compact.regular.size20};
    color: ${COLORS.textLightPrimary};
    ${zIndexStyles};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            text-align: center;
        `,
    )};
`;

export const BecomeAgentButton = styled(MainButton)`
    ${paddingButtonStyles};
    ${buttonMobileStyles};
    ${zIndexStyles};
`;

export const ReferralLinkButton = styled(MainButton)`
    ${paddingButtonStyles};
    ${buttonMobileStyles};
    ${zIndexStyles};
`;

export const NewLeadButton = styled(MainButton)`
    ${paddingButtonStyles};
    ${newLeadButtonStyles};
    ${zIndexStyles};

    &:hover {
        ${newLeadButtonStyles};
    }

    ${buttonMobileStyles};
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: ${rem(20)};
`;
